import React, { useState } from 'react';
import { LayoutDashboard, Package, Truck, History, Settings, Bell, Search, User, LogOut, Store } from 'lucide-react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface POSLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function POSLayout({
  children,
  activeTab,
  onTabChange
}: POSLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navItems = [{
    id: 'dashboard',
    label: 'Order Queue',
    icon: LayoutDashboard
  }, {
    id: 'history',
    label: 'Order History',
    icon: History
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }];
  return <div className="flex h-screen bg-[#F1F5F9] font-sans text-slate-900 overflow-hidden" data-id="element-748" data-mp="28397bbunkdlg">
      {/* Sidebar */}
      <aside className={cn('bg-[#0F172A] text-white flex flex-col transition-all duration-300', isSidebarOpen ? 'w-64' : 'w-20')} data-id="element-749" data-mp="1erbha3a3oj4t">
        <div className="p-6 flex items-center gap-3 border-b border-slate-800" data-id="element-750" data-mp="1jjl2j609sv0r">
          <div className="bg-blue-600 p-2 rounded-lg" data-id="element-751" data-mp="14uox7gpllw3u">
            <Store className="w-6 h-6" data-id="element-752" data-mp="19r6y25ht5aaw" />
          </div>
          {isSidebarOpen && <div className="overflow-hidden whitespace-nowrap" data-id="element-753" data-mp="1xhswr65x9i88">
              <h1 className="font-bold text-lg leading-tight" data-id="element-754" data-mp="1xfgdmpofh1tl">Innova Health</h1>
              <p className="text-xs text-slate-400" data-id="element-755" data-mp="22g467fsb1qpx">Branch: Riyadh Central</p>
            </div>}
        </div>

        <nav className="flex-1 py-6 px-3 space-y-2" data-id="element-756" data-mp="1oixnfl7kzs0p">
          {navItems.map(item => <button key={item.id} onClick={() => onTabChange(item.id)} className={cn('w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-colors', activeTab === item.id ? 'bg-blue-600 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white')} data-id="element-757" data-mp="1skj8htu9rclz">
              <item.icon className="w-6 h-6 shrink-0" data-id="element-758" data-mp="2esyd6zyhshdn" />
              {isSidebarOpen && <span className="font-medium" data-id="element-759" data-mp="29y2a94rpw9lr">{item.label}</span>}
            </button>)}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden" data-id="element-760" data-mp="210i4pjmtnr5c">
        {/* Top Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 shrink-0" data-id="element-761" data-mp="1w046suexpxl1">
          <div className="flex items-center gap-4 flex-1 max-w-xl" data-id="element-762" data-mp="1r22gbof6ivzj">
            <div className="relative w-full" data-id="element-763" data-mp="1m2priy4qzeub">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-764" data-mp="1m40uwwua6kkw" />
              <input type="text" placeholder="Search orders, customers, or items..." className="w-full pl-10 pr-4 py-2 bg-slate-100 border-transparent focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 rounded-lg text-sm transition-all outline-none" data-id="element-765" data-mp="3leis14qqv2bs" />
            </div>
          </div>
        </header>

        {/* Page Area */}
        <div className="flex-1 overflow-auto p-8" data-id="element-766" data-mp="1m8iiut2qr5d">{children}</div>
      </main>
    </div>;
}